import type { Guide } from '@/lib/guides/types/guide'

/** Stable reference for a spread with no ruler guides — a module-level constant rather than a fresh
 *  `[]` per render, so the memoized `CenterCanvas` doesn't re-render on its identity. */
export const EMPTY_GUIDES: Guide[] = []
